<template>
	<div>
		<a-modal v-show='!ishand' id='xiangqing' width='45rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: '30vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'><div v-html='"用戶詳情"' style="width: 43rem;"></div></div>
			<div solt='title'>
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 43rem;" class='body_lis'>
				<div style="padding-top: 1.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" 
						hideRequiredMark >
							<a-form-model-item prop='remark' label='證券帳號'>{{record.username}}</a-form-model-item>
							<a-form-model-item prop='remark' label='電話號碼'>{{record.mobile}}</a-form-model-item>
							<a-form-model-item prop='remark' label='出生日期'>
							<div v-if='record.khuser_flag'>
								{{record.birth}}
								<!-- <img src="require('@/image/lea/bianji4.png')" alt=""> -->
							</div>
							<div v-else>
								<a-date-picker v-model='form.birth' @change="onChange" placeholder=' ' v-if='useradmin'/>
								<img :src="require('@/image/baocun.png')" alt="" @click='getfrom'
								 style="margin-left: 1rem;"  v-if='useradmin'>
							</div>
							</a-form-model-item>
							<a-form-model-item prop='remark' label='上次登入'>{{record.logintime}}</a-form-model-item>
							<div id='whand'>
							<a-form-model-item prop='remark' label='電子郵箱' style='width: 100%;'>{{record.email}}</a-form-model-item></div>
					</a-form-model>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	
	export default {
		props: ['record'],
		data() {
			return {
				useradmin: this.$store.state.rolesdata.indexOf('useradmin') >= 0,
				ishand: false,
				visible: true,
				form: {
					birth:''
				},
			}
		},
		created() {
			let _this = this
			_this.form = JSON.parse(JSON.stringify(_this.record))
			if(_this.form.birth){
				let arr = _this.form.birth.split('/')
				arr = arr.reverse()
				 _this.form.birth = arr.join('-')
			}
		},
		mounted(){
		},
		methods: {
			getfrom(){
				this.form.birth = new Date(this.form.birth)
				this.form.birth = this.form.birth ? App.oDate.secsTime3(this.form.birth) : '';
				
				this.$ajax({
					method:'post',
					url:this.$api.editQmisUserMsg,
					data:{
						"username":this.record.username,
						"birth":this.form.birth
					}
				}).then(res=>{
					if(res.data.qmiscode===1000){
						// this.$emit('child', 1)
						this.$message.success(res.data.qmismsg)
					}
				})
			},
			onChange(){},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#xiangqing{
		#whand{
			.ant-form-item-label {
				width: 9% ;
			}
		}
	}
	#xiangqing .ant-modal-header,
	#xiangqing .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#xiangqing {
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}
		.ant-form-item-label {
			width: 18%;
		}
		.ant-form-item{
			width: 50%;
		}
		.ant-form-item label {
			font-size: .8rem !important;
		}
		.ant-form-item-children{
			font-size: .8rem !important;
		}
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
